<template>
    <div class="home-container">
        <section class="d-flex flex-column align-items-start gap-3">
            <h4 class="extra-large-text">პრობლემების ანალიტიკური ინფორმაცია</h4>
            <div class="common-statistics w-100">
                <commonStatisticsBlock visualWrapperHeight="55px" class="cursor-pointer" @click="activateModalMode('statisticCardCity', true)">
                    <template v-slot:title>
                        <h6 class="light-text extra-gray-color">ყველაზე პრობლემური ქალაქი</h6>
                    </template>
                    <template v-slot:correspondingInfo>
                        <p v-if="problemStatisticsInfo?.mostProblematicCity" class="after-extra-large-text extra-black-color">{{ `${problemStatisticsInfo.mostProblematicCity.city}: ${problemStatisticsInfo.mostProblematicCity.usr_pr_count}` }}</p>
                        <p v-else></p>
                    </template>
                    <template v-slot:chart>
                        <commonStatisticsBarChart mode="green"/>
                    </template>
                </commonStatisticsBlock>
                <commonStatisticsBlock visualWrapperHeight="55px" class="cursor-pointer" @click="activateModalMode('statisticCardRegion', true)">
                    <template v-slot:title>
                        <h6 class="light-text extra-gray-color">ყველაზე პრობლემური უბანი თბილისში</h6>
                    </template>
                    <template v-slot:correspondingInfo>
                        <p v-if="problemStatisticsInfo?.mostProblematicRegion" class="after-extra-large-text extra-black-color">{{ `${problemStatisticsInfo.mostProblematicRegion.region}: ${problemStatisticsInfo.mostProblematicRegion.usr_pr_count}` }}</p>
                        <p v-else></p>
                    </template>
                    <template v-slot:chart>
                        <commonStatisticsBarChart mode="orange"/>
                    </template>
                </commonStatisticsBlock>
                <commonStatisticsBlock visualWrapperHeight="55px" class="cursor-pointer" @click="activateModalMode('statisticCardProblem', true)">
                    <template v-slot:title>
                        <h6 class="light-text extra-gray-color">ხშირად დასახელებული</h6>
                    </template>
                    <template v-slot:correspondingInfo>
                        <p v-if="problemStatisticsInfo?.mostProblematicTypeCount" class="after-extra-large-text extra-black-color">{{ `${problemStatisticsInfo.mostProblematicTypeCount.problem_type}: ${problemStatisticsInfo.mostProblematicTypeCount.sum_pr}` }}</p>
                        <p v-else></p>
                    </template>
                    <template v-slot:chart>
                        <commonStatisticsBarChart mode="red"/>
                    </template>
                </commonStatisticsBlock>
                <commonStatisticsBlock visualWrapperHeight="55px">
                    <template v-slot:title>
                        <h6 class="light-text font-weight-600">სულ პრობლემების რაოდენობა <span class="extra-red-color extra-large-text">{{ problemStatisticsInfo?.mostProblematicOveralCount?problemStatisticsInfo.mostProblematicOveralCount:0 }}</span> </h6>
                    </template>
                    <template v-slot:correspondingInfo>
                        <ul v-if="problemStatisticDetailedInfo">
                            <li v-for="(data, i) of problemStatisticDetailedInfo.mostProblematicOveralCountByType">
                                <p :class="['light-text', {'extra-red-color': data.problem_statusID == 1}, {'extra-orange-color': data.problem_statusID == 2}, {'extra-green-color': data.problem_statusID == 3}, 'font-weight-600']">{{ `${data.problem_statuse}: ` }} <span class="large-text">{{ data.sum_count }}</span></p>
                            </li>
                        </ul>
                    </template>
                    <template v-slot:chart>
                        <commonStatisticsBarChart mode="blue"/>
                    </template>
                </commonStatisticsBlock>
            </div>
        </section>
        <section class="main-info-section d-flex flex-column gap-3 align-items-start">
            <h3 class="extra-large-text">პრობლემები</h3>
            
            <div :class="['d-flex', 'search-container', 'w-100', 'align-items-start']">
                <form class="search-container-form" @submit.prevent = "submitProblemsFilters()">
                    <fieldset class="filters-wrapper">
                        <Multiselect v-for="(data, i) of problemSearchMultiselectArray" name="search" id="search" v-model="problemsFiltersInfoObj.search" :options="data.options" :mode="data.mode"
                            :searchable="true" :loading="false" :close-on-select="false" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
                            class="extra-light-text light-blue-color custom-multiselect without-max-width" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert>
                            
                            <template v-slot:multiplelabel="{ values }">
                                <div class="multiselect-multiple-label">
                                {{ values.length }} პარამეტრი
                                </div>
                            </template>
                        </Multiselect>
                        <fieldset>
                            <datePicker :datePickerMode="1" :rangeVmodelKeeper="problemsFiltersInfoObj.date" indicator="dateFilter" :isRequired="false" @update="handleDate"/>
                        </fieldset>
                        <Multiselect v-for="(data, i) of problemTypeSortMultiselectArray" name="problemTypeIDs" id="problemTypeIDs" v-model="problemsFiltersInfoObj.problemTypeIDs" :options="data.options" :mode="data.mode"
                            :searchable="true" :loading="false" :close-on-select="false" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
                            class="extra-light-text light-blue-color custom-multiselect without-max-width" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert>
                            
                            <template v-slot:multiplelabel="{ values }">
                                <div class="multiselect-multiple-label">
                                {{ values.length }} პრობლემის ტიპი
                                </div>
                            </template>
                        </Multiselect>
                        <Multiselect v-for="(data, i) of seentMultiselectArray" name="seen" id="seen" v-model="problemsFiltersInfoObj.seen" :options="data.options" :mode="data.mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
                            class="extra-light-text light-blue-color custom-multiselect without-max-width" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert>
                        </Multiselect>


                        <Multiselect v-for="(data, i) of problemFiltersStatusesMultiselectArray" name="problemFiltersStatus" id="problemFiltersStatus" v-model="problemsFiltersInfoObj.status" :options="data.options" :mode="data.mode"
                            :searchable="true" :loading="false" :close-on-select="false" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
                            class="extra-light-text light-blue-color custom-multiselect without-max-width" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert>
                            
                            <template v-slot:multiplelabel="{ values }">
                                <div class="multiselect-multiple-label">
                                {{ values.length }} სტატუსი
                                </div>
                            </template>
                        </Multiselect>



                        <!-- <Multiselect v-for="(data, i) of problemFiltersStatusesMultiselectArray" name="problemFiltersStatus" id="problemFiltersStatus" v-model="problemsFiltersInfoObj.status" :options="data.options" :mode="data.mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="false" locale="ge" :canDeselect="true" :canClear="true" :required="false"
                            class="extra-light-text light-blue-color custom-multiselect without-max-width" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/> -->

                        
                        <Multiselect ref="cityID" v-model="problemsFiltersInfoObj.cityID" :options="this.problemsFiltersMultiselectsArray[1].options" :mode="this.problemsFiltersMultiselectsArray[1].mode"
                        :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1" id="cityID"
                        :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 2, true, true, problemsFiltersMultiselectsArray, problemsFiltersInfoObj)" @deselect="() => blockNextMultiselects(2, problemsFiltersMultiselectsArray, problemsFiltersInfoObj)" @clear="() => blockNextMultiselects(2, problemsFiltersMultiselectsArray, problemsFiltersInfoObj)"
                        class="extra-light-text light-blue-color without-max-width" autocomplete="off" :placeholder="this.problemsFiltersMultiselectsArray[1].placeholder" :disabled="this.problemsFiltersMultiselectsArray[1].isDisabled" insert/>
                        <Multiselect ref="regionID" v-model="problemsFiltersInfoObj.regionID" :options="this.problemsFiltersMultiselectsArray[2].options" :mode="this.problemsFiltersMultiselectsArray[2].mode"
                        :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                        :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 3, true, true, problemsFiltersMultiselectsArray, problemsFiltersInfoObj)" @deselect="() => blockNextMultiselects(3, problemsFiltersMultiselectsArray, problemsFiltersInfoObj)" @clear="() => blockNextMultiselects(3, problemsFiltersMultiselectsArray, problemsFiltersInfoObj)"
                        class="extra-light-text light-blue-color without-max-width" autocomplete="off" :placeholder="this.problemsFiltersMultiselectsArray[2].placeholder" :disabled="this.problemsFiltersMultiselectsArray[2].isDisabled" insert/>
                        
                        <button type="submit" class="extra-light-text ms-2 secondary-submit-btn">გაფილტვრა</button>
                        <button @click="resetProblemsFilters()" type="button" class="extra-light-text extra-red-color ms-2" style="font-weight: 600; background-color: transparent;">გასუფთავება</button>
                    </fieldset>
                </form>
            </div>


            <div class="problems-cards-map-wrapper w-100 mt-1">
                <div class="d-flex flex-column align-items-center gap-3">
                    <div class="w-100 d-flex justify-content-between gap-3 align-items-center">
                        <div class="d-flex flex-column gap-1 align-items-center bg-secondary-background border-radius-10 cursor-pointer" style="padding: 9px 25px; width: 20%;" @click="activateModalMode('statisticCardOverallProblemStatuses', true)">
                            <h6 class="light-text font-weight-600" style="line-height: 22px;">რაოდენობა:</h6>
                            <p class="light-text font-weight-600 middle-red-color">{{ this.problemsPagingInfo.total }}</p>
                        </div>
                        <div class="d-flex flex-column gap-1 align-items-center bg-secondary-background border-radius-10 cursor-pointer" style="padding: 9px 25px; width: 60%;" @click="activateModalMode('statisticCardProblemFiltered', true)">
                            <h6 class="light-text font-weight-600 text-start" style="line-height: 22px;">ხშირად დასახელებული პრობლემა:</h6>
                            <p class="light-text font-weight-600 middle-red-color text-ellipsis">{{ this.problemStatisticDetailedFilteredInfo?.mostProblematicTypeCountList[0]? this.problemStatisticDetailedFilteredInfo?.mostProblematicTypeCountList[0]?.problem_type:"" }}</p>
                        </div>
                        <excelFileDownloadComponent @igniteDownload="problemsIgniteDownload" excelFileName="problems" :namesArray="['პრობლემები']" :jsonToExcelArray="problemsJsonToExcelArray" :downloadInAction="problemsDownloadInAction" @abortDownload="problemsExcelDownloadAbort()" :canAbortDownload="true"/>
                    </div>
                    <div class="cards-common-grid-wrapper" ref="cardsCommonGridWrapper">
                        <template v-for="(item, i) of problemsArray">
                            <commonCardAccordion v-if="!isAccordionOpened || indexOfOpenedAccordion == i" :allowStaticClose="true" :index="i" :closeTrigger="accordionCloseTrigger" @openAccordionOnIndex="openAccordionOnIndex(i, item.user_problemID)" @closeAccordionOnIndex="closeAccordionOnIndex" accordionHeaderPadding="12px 14px">
                                <template v-slot:middle>
                                    <div class="d-flex align-items-center gap-1 justify-content-between w-100">
                                        <div v-if="!isAccordionOpened" class="d-flex flex-column align-items-start gap-1" style="width: 160px;">
                                            <p :class="['light-text', 'font-weight-600', 'light-blue-color', 'text-ellipsis']">{{item?.problem_type?.problem_type}}</p>
                                            <div v-if="!isAccordionOpened" class="d-flex align-items-center gap-2">
                                                <p class="text-start light-black-color text-start light-text">{{ item?.input_date??"-----------" }}</p>
                                            </div>
                                        </div>
                                        <div v-if="isAccordionOpened" class="d-flex flex-column align-items-start gap-1" style="width: fit-content;">
                                            <p :class="['light-text', 'font-weight-600', 'light-blue-color']">{{item?.problem_type?.problem_type}}</p>
                                            <div v-if="!isAccordionOpened" class="d-flex align-items-center gap-2">
                                                <p class="text-start light-black-color text-start light-text">{{ item?.input_date??"-----------" }}</p>
                                            </div>
                                        </div>
                                        <p :class="['light-text', 'font-weight-600', {'extra-red-color': item.problem_status.problem_statusID == 1}, 
                                                {'extra-orange-color': item.problem_status.problem_statusID == 2}, {'extra-green-color': item.problem_status.problem_statusID == 3}, 'd-none', 'd-xxl-block',
                                            ]" style="text-align: center; width: max-content;">{{ item.problem_status.problem_statuse }}</p>
                                        <div :class="['d-flex', 'align-items-center', {'gap-4': isAccordionOpened}, {'gap-3': !isAccordionOpened}, 'justify-content-end']">
                                            <div v-if="!isAccordionOpened" class="d-flex flex-column align-items-end" style="width: 120px;">
                                                <p v-if="item?.region?.region" class="light-text font-weight-600 light-black-color text-end text-ellipsis">{{ (item?.region?.region)??"უცნობია" }}</p>
                                                <p v-else class="light-text font-weight-600 light-black-color text-end text-ellipsis">{{ (item?.city?.city)??"უცნობია" }}</p>
                                                <p :class="['light-text', 'font-weight-500', 'text-ellipsis', {'extra-red-color': item.problem_status.problem_statusID == 1}, 
                                                    {'extra-orange-color': item.problem_status.problem_statusID == 2}, {'extra-green-color': item.problem_status.problem_statusID == 3}, 'text-end', 'd-block', 'd-xxl-none',
                                                ]">{{ item.problem_status.problem_statuse }}</p>
                                            </div>
                                            <img v-if="isAccordionOpened" src="@\assets\images\correctionButton.svg" @click="editClickHandler(item)" class="cursor-pointer" alt="edit">
                                            <img v-if="isAccordionOpened" src="@\assets\images\tableDeleteButton.svg" @click="deleteClickHandler(item)" class="cursor-pointer" alt="delete">
                                            <img src="@\assets\images\seen.svg" style="width: 18px; height: 18px;" v-if="item?.seen == 1" alt="seen">
                                            <div v-else style="width: 18px; height: 18px;"></div>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:additionalInfo>
                                    <div class="d-flex flex-column gap-3 align-items-start">
                                        <article class="d-flex flex-column gap-2 align-items-start w-100">
                                            <h4 class="light-text font-weight-600 light-black-color">დამატებითი ტექსტი</h4>
                                            <textarea readonly :id="'additional-text'+i" :name="'additional-text'+i" cols="100" rows="10" placeholder="დამატებითი ტექსტი" class="blue-part-input extra-light-text w-100">{{ item.comment }}</textarea>
                                        </article>
                                        <article class="d-flex flex-column gap-3 align-items-start w-100 overflow-hidden">
                                            <h4 class="light-text font-weight-600 light-black-color">ვიზუალური მასალა</h4>
                                            <ul class="problem-images-wrapper d-flex align-items-start justify-content-start flex-nowrap gap-2 common-horizontal-overflow w-100 common-scrollbar">
                                                <template v-if="item?.problem_files?.length > 4" v-for="(problemFile, i) of item?.problem_files">
                                                    <li v-if="problemFile?.file_type == 1">
                                                        <img loading="lazy" @click="photoClickHandler(`data:image/jpeg;base64,${problemFile.problem_file}`, `${item?.problem_type?.problem_type}_${item?.input_date.slice(0, 10)}.jpg`, item, problemFile)" class="cursor-pointer" :src="`data:image/jpeg;base64,${problemFile.problem_file}`" alt="image">
                                                    </li>
                                                    <li v-else-if="problemFile?.file_type == 2">
                                                        <button @click="activateModalMode('video', true), getProblemVideo(problemFile.problem_file, item.user_problemID, item, problemFile)" class="image-alternative d-flex align-items-center justify-content-center large text border-radius-10" style="background-color: var(--extra-green); color: var(--secondary-background-color); cursor: pointer">ვიდეო მასალა</button>
                                                    </li>
                                                    <li v-else-if="problemFile?.file_type == 3">
                                                        <button @click="activateModalMode('audio', true), getProblemAudio(problemFile.problem_file, item.user_problemID, item, problemFile)" class="image-alternative d-flex align-items-center justify-content-center large text border-radius-10" style="background-color: var(--extra-green); color: var(--secondary-background-color); cursor: pointer">აუდიო მასალა</button>
                                                    </li>
                                                </template>
                                                <template v-else v-for="(justData, i) of [1, 2, 3, 4]">
                                                    <li v-if="item?.problem_files[i]?.file_type == 1">
                                                        <img loading="lazy" @click="photoClickHandler(`data:image/jpeg;base64,${item?.problem_files[i].problem_file}`, `${item?.problem_type?.problem_type}_${item?.input_date.slice(0, 10)}.jpg`, item, item.problem_files[i])" class="cursor-pointer" :src="`data:image/jpeg;base64,${item?.problem_files[i].problem_file}`" alt="image">
                                                    </li>
                                                    <li v-else-if="item?.problem_files[i]?.file_type == 2">
                                                        <button @click="activateModalMode('video', true), getProblemVideo(item.problem_files[i].problem_file, item.user_problemID, item, item.problem_files[i])" class="image-alternative d-flex align-items-center justify-content-center large text border-radius-10" style="background-color: var(--extra-green); color: var(--secondary-background-color); cursor: pointer">ვიდეო მასალა</button>
                                                    </li>
                                                    <li v-else-if="item?.problem_files[i]?.file_type == 3">
                                                        <button @click="activateModalMode('audio', true), getProblemAudio(item.problem_files[i].problem_file, item.user_problemID, item, item.problem_files[i])" class="image-alternative d-flex align-items-center justify-content-center large text border-radius-10" style="background-color: var(--extra-green); color: var(--secondary-background-color); cursor: pointer">აუდიო მასალა</button>
                                                    </li>
                                                    <li v-else>
                                                        <div class="image-alternative d-flex align-items-center justify-content-center large text border-radius-10" style="background-color: gray; color: var(--secondary-background-color)">empty</div>
                                                    </li>
                                                </template>
                                                
                                            </ul>
                                        </article>
                                        <article class="d-flex flex-column gap-2 align-items-start w-100 primary-helper-card">
                                            <ul class="d-flex flex-row align-items-center justify-content-start justify-content-xl-between extra-light-text light-blue-color w-100 flex-wrap pe-xl-5">
                                                <li class="d-flex flex-column align-items-start">
                                                    <h6 class="light-text font-weight-600 light-black-color text-start">ქალაქი</h6>

                                                    <p v-if="item?.city?.city" class="text-start">{{ `${item?.city?.city}` }}</p>
                                                    <p v-else class="text-start">---------------</p>
                                                </li>
                                                <li>
                                                    <h6 class="light-text font-weight-600 light-black-color text-start">უბანი</h6>
                                                    <p v-if="item?.region?.region || item?.city?.city" class="text-start">{{ item?.region?.region??item?.city?.city }}</p>
                                                    <p v-else class="text-start">---------------</p>
                                                </li>
                                                <li>
                                                    <h6 class="light-text font-weight-600 light-black-color text-start">მისამართი</h6>
                                                    <p v-if="item?.address" class="text-start">{{item?.address }}</p>
                                                    <p v-else class="text-start">---------------</p>
                                                </li>
                                            </ul>
                                        </article>
                                        <article class="d-flex flex-column gap-2 align-items-start w-100 primary-helper-card">
                                            <h4 class="light-text font-weight-600 light-black-color text-start">რესპოდენტის მონაცემები</h4>
                                            <ul class="d-flex flex-row align-items-center justify-content-start justify-content-xl-between extra-light-text light-blue-color w-100 flex-wrap pe-xl-5">
                                                <li class="d-flex flex-column align-items-start">
                                                    <h6 class="light-black-color text-start">სახელი გვარი</h6>
                                                    <p v-if="item?.respodent?.name" class="text-start">{{ `${item?.respodent?.name} ${item.respodent.surename}` }}</p>
                                                    <p v-else class="text-start">---------------</p>
                                                </li>
                                                <li>
                                                    <h6 class="light-black-color text-start">ტელეფონი</h6>
                                                    <p v-if="item?.respodent?.phone" class="text-start">{{ item?.respodent?.phone }}</p>
                                                    <p v-else class="text-start">---------------</p>
                                                </li>
                                                <li></li>
                                            </ul>
                                        </article>
                                        <article class="d-flex align-items-center justify-content-between w-100 flex-wrap gap-3 primary-helper-card">
                                            <ul class="d-flex flex-row align-items-center justify-content-start justify-content-xl-between extra-light-text light-blue-color w-100 flex-wrap pe-xl-5">
                                                <li>
                                                    <h6 class="light-black-color text-start light-text font-weight-600">თანამშრომელი</h6>
                                                    <p v-if="item?.user?.name" class="text-start">{{ `${item?.user?.name} ${item?.user?.surename}` }}</p>
                                                    <p v-else class="text-start">-----------</p>
                                                </li>
                                                <li>
                                                    <h6 class="light-black-color text-start light-text font-weight-600">ოფისი</h6>
                                                    <p v-if="item?.user?.office" class="text-start">{{ `${item?.user?.office?.office_name}` }}</p>
                                                    <p v-else class="text-start">-----------</p>
                                                </li>
                                                <li>
                                                    <h6 class="light-black-color text-start light-text font-weight-600">მობილური</h6>
                                                    <p v-if="item?.user?.phone" class="text-start">{{ `${item?.user?.phone}` }}</p>
                                                    <p v-else class="text-start">-----------</p>
                                                </li>
                                            </ul>
                                        </article>
                                        <article class="d-flex align-items-center justify-content-between w-100 flex-wrap gap-3">
                                            <ul class="d-flex flex-row align-items-center justify-content-start extra-light-text light-blue-color flex-wrap gap-3 gap-xl-4 mt-3">
                                                <li class="d-flex flex-column align-items-start">
                                                    <h6 class="light-black-color text-start light-text font-weight-600">დამატების თარიღი</h6>
                                                    <p class="text-start light-text">{{ item?.input_date??"-----------" }}</p>
                                                </li>
                                            </ul>
                                        </article>
                                        <div class="additional-comment d-flex justify-content-end align-items-center w-100">
                                            <!-- <div>
                                                <button style="cursor: default;">
                                                    <img src="@/assets/images/printer-green.svg" style="width: 27px; height: 27px;" alt="download">
                                                </button>
                                            </div> -->
                                            <div class="d-flex align-items-center gap-2">
                                                <button @click="statusChangeClickHandler(item)" :class="['blue-part-input', 'green', 'light-text', 'font-weight-500']">
                                                    <p>სტატუსის შეცვლა</p>
                                                </button>
                                                <button @click="additionalCommentClickHandler('additionalComment', true, item)" :class="['blue-part-input', 'green', 'light-text', 'font-weight-500']">
                                                    <p>ვიზირება</p>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </commonCardAccordion>
                        </template>
                    </div>
                    <vue-awesome-paginate
                        :total-items="problemsPagingInfo.total"
                        :items-per-page="problemsPagingInfo.limit"
                        :max-pages-shown="4"
                        v-model="problemsPagingInfo.offset"
                        :hide-prev-next-when-ends="false"
                        @click="paginationClickHandler"
                        class="my-3"
                    />
                </div>
                <div class="problems-map-wrapper p-3 border-radius-10" style="height: min-content;">
                    <markerMapComponent height="600px" @getMarkerInfo="manageProblemFiltersWithIDFromMap" :markersInfo="markerInfoArray" :zoomOn="zoomedMarkerIndex" :currentCenter="this.markerMapCurrentCenter" :unzoomMapLevel="unzoomMapLevel"/>
                </div>
            </div>
        </section>
    </div>
    <primaryModalComponent :showModal="showModal" maxHeight="781px" maxWidth="900px" @closeModal="triggerModal">
        <template v-slot:modal-content>
            <div class="d-flex flex-column align-items-stretch gap-4">
                <h5 class="extra-large-text">
                    {{ `${modalTitle}` }}
                    <span class="extra-green-color">{{ `${modalSubTitle}` }}</span>
                </h5>
                <div class="modal-photo-wrapper" v-if="modalMode == 'photo'">
                    <mediaShowDownload :photoURl="this.photoUrl" :name="this.photoDownloadName" :disabledProp="isSending" @deleteClick="deleteProblemMediaFiles()"/>
                </div>
                <div class="modal-photo-wrapper" v-if="modalMode == 'audio'">
                    <button :disabled="isSending" v-if="audioURL" class="delete-button" @click="deleteProblemMediaFiles()">
                        <span class="extra-red-color light-text">წაშლა</span>
                        <img src="@\assets\images\tableDeleteButton.svg" alt="delete">
                    </button>
                    <audio controls :src="audioURL" style="align-self: center;">

                    </audio>
                </div>
                <div class="modal-photo-wrapper" v-if="modalMode == 'video'">
                    <button :disabled="isSending" v-if="videoURL" class="delete-button" @click="deleteProblemMediaFiles()">
                        <span class="extra-red-color light-text">წაშლა</span>
                        <img src="@\assets\images\tableDeleteButton.svg" alt="delete">
                    </button>
                    <video controls :src="videoURL" style="object-fit: contain; width: 100%">

                    </video>
                </div>
                <div v-if="modalMode == 'additionalComment'" class="d-flex flex-column align-items-stretch">
                    <form class="d-flex flex-column align-items-center" @submit.prevent="addAdditionalComment()">
                        <textarea v-model="problemObjForAdditionalCommentVmodel" placeholder="დამატეთ კომენტარი"  required id="additionalComment" name="additionalComment" maxlength="200" class="blue-part-input large-text" style="max-width: none;" rows="10"></textarea>
                        <primaryButtonComponent buttonType="submit" class="large-text mt-2" :disabled="isSending">
                            <template v-slot:content>
                                დადასტურება
                            </template>
                        </primaryButtonComponent>
                    </form>
                    <ul class="problems-comments-wrapper w-100 d-flex flex-column align-items-center gap-2 common-vertical-overflow common-scrollbar mt-3">
                        <li v-if="this.openedProblemObj?.vizireba?.length > 0" v-for="(commentObj, i) of this.openedProblemObj.vizireba" class="primary-helper-card d-flex flex-column align-items-start gap-2 extra-black-color light-text w-100">
                            <div class="d-flex align-items-center justify-content-between w-100">
                                <h6 class="large-text font-weight-600 extra-black-color">{{ `${commentObj?.added_by.name} ${commentObj?.added_by.surename}` }}</h6>
                                <span class="extra-light-text">{{ `${commentObj?.add_date}` }}</span>
                            </div>
                            <div class="d-flex flex-column align-items-start align-items-start w-100">
                                <p class="light-text text-start"> {{ `${commentObj?.vizireba}` }}</p>
                            </div>
                            </li>
                            <li v-else class="primary-helper-card d-flex flex-column align-items-start gap-2 extra-black-color light-text">
                            <h6 class="light-text extra-black-color">კომენტარები არ დაწერილა</h6>
                        </li>
                    </ul>
                </div>
                <div v-if="modalMode == 'deleteProblem'" class="d-flex align-items-center justify-content-center gap-3">
                    <primaryButtonComponent :disabled="isSending" @click="deleteProblem()" buttonType="button" buttonWidth="min-content" class="large-text mt-4">
                        <template v-slot:content>
                            წაშლა
                        </template>
                    </primaryButtonComponent>
                    <primaryButtonComponent @click="triggerModal(false)" :mode="1" buttonType="button" buttonWidth="min-content" class="large-text mt-4">
                        <template v-slot:content>
                            გაუქმება
                        </template>
                    </primaryButtonComponent>
                </div>
                <div v-if="modalMode == 'changeStatus'" class="d-flex flex-column align-items-center">
                    <form @submit.prevent="changeStatusHandler()" class="w-100">
                        <Multiselect v-for="(data, i) of problemStatusesMultiselectArray" name="problemStatus" id="problemStatus" v-model="data.vmodel" :options="data.options" :mode="data.mode"
                        :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                        :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                        class="extra-light-text light-blue-color" style="width: 60%; min-width: 340px; margin: 0 auto;" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
                        <primaryButtonComponent :disabled="isSending" :mode="1" buttonType="submit" buttonWidth="min-content" class="large-text mt-4">
                            <template v-slot:content>
                                დადასტურება
                            </template>
                        </primaryButtonComponent>
                    </form>
                </div>
                <div v-if="modalMode == 'editProblem'"  class="">
                    <form @submit.prevent="editProblem()" class="modal-form-grid-wrapper w-100">
                        <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                            <label for="problemTypeID">პრობლემის ტიპი</label>
                            <Multiselect v-for="(data, i) of problemTypesMultiselectArray" name="problemTypeID" id="problemTypeID" v-model="editProblemVmodels.problem_typeID" :options="data.options" :mode="data.mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
                        </fieldset>

                        <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
                            <label for="problemEditCityID">ქალაქი</label>
                            <Multiselect  v-model="editProblemVmodels.cityID" id="problemEditCityID" name="problemEditCityID" :options="this.editProblemAreaVmodelsMultiselectsArray[1].options" :mode="this.editProblemAreaVmodelsMultiselectsArray[1].mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1" :required="true"
                            :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 2, true, true, editProblemAreaVmodelsMultiselectsArray, editProblemVmodels)" @deselect="() => blockNextMultiselects(2, editProblemAreaVmodelsMultiselectsArray, editProblemVmodels)" @clear="() => blockNextMultiselects(2, editProblemAreaVmodelsMultiselectsArray, editProblemVmodels)"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.editProblemAreaVmodelsMultiselectsArray[1].placeholder" :disabled="this.editProblemAreaVmodelsMultiselectsArray[1].isDisabled" insert/>
                        </fieldset>
                        <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                            <label for="problemEditRegionID">უბანი</label>
                            <Multiselect v-model="editProblemVmodels.regionID" id="problemEditRegionID" name="problemEditRegionID" :options="this.editProblemAreaVmodelsMultiselectsArray[2].options" :mode="this.editProblemAreaVmodelsMultiselectsArray[2].mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1" :required="true"
                            :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 3, true, true, editProblemAreaVmodelsMultiselectsArray, editProblemVmodels)" @deselect="() => blockNextMultiselects(3, editProblemAreaVmodelsMultiselectsArray, editProblemVmodels)" @clear="() => blockNextMultiselects(3, editProblemAreaVmodelsMultiselectsArray, editProblemVmodels)"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.editProblemAreaVmodelsMultiselectsArray[2].placeholder" :disabled="this.editProblemAreaVmodelsMultiselectsArray[2].isDisabled" insert/>
                        </fieldset>
                        <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
                            <label for="problemAddress">მისამართი</label>
                            <input v-model="editProblemVmodels.address" type="text" id="problemAddress" name="problemAddress" class="blue-part-input smaller extra-light-text" placeholder="მისამართი">
                        </fieldset>
                        <fieldset style="grid-column: 1 / 3;" class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                            <label for="problemComment">კომენტარი</label>
                            <textarea v-model="editProblemVmodels.comment" id="problemComment" name="problemComment" style="max-width: 1000px;" maxlength="150" class="blue-part-input large-text" rows="10"></textarea>
                        </fieldset>
                        <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                            <label for="editProblemPhoto">ფოტო მასალა</label>
                            <fileUpload @filesBeenAdded="getPhotosForProblemEdit" :filesEmptier="filesEmptierForProblemEdit" :idIndicator="1" :limit="(typeof openedProblemObj?.photoCount == 'number' && openedProblemObj?.photoCount < 5)?5 - openedProblemObj.photoCount:0"/>
                        </fieldset>
                        <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
                            <label for="editProblemVideo">ვიდეო მასალა</label>
                            <fileUpload @filesBeenAdded="getVideosForProblemEdit" :filesEmptier="filesEmptierForProblemEdit" :idIndicator="2" :limit="(typeof openedProblemObj?.videoCount == 'number' && openedProblemObj?.videoCount < 2)?2 - openedProblemObj.videoCount:0" mode="video" accept="video/mp4"/>
                        </fieldset>
                        <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                            <label for="editProblemAudio">აუდიო მასალა</label>
                            <fileUpload @filesBeenAdded="getAudiosForProblemEdit" :filesEmptier="filesEmptierForProblemEdit" :idIndicator="3" :limit="(typeof openedProblemObj?.audioCount == 'number' && openedProblemObj?.audioCount < 2)?2 - openedProblemObj.audioCount:0" mode="audio" accept="audio/wav"/>
                        </fieldset>

                        <fieldset class="d-flex flex-column align-items-center justify-content-center gap-1" style="grid-column: 1 / 3;">
                            <primaryButtonComponent :disabled="isSending" :mode="1" buttonType="submit" buttonWidth="min-content" class="large-text mt-4">
                                <template v-slot:content>
                                    დადასტურება 
                                </template>
                            </primaryButtonComponent>
                            <div v-if="isSending" class="spinner-border text-dark" role="status">
                            </div>
                        </fieldset>
                    </form>
                </div>
                <div v-if="modalMode.startsWith('statisticCard')">
                    <div :class="[{'modal-reports-wrapper': modalMode == 'statisticCardCity' || modalMode == 'statisticCardRegion' || modalMode == 'statisticCardProblem'}, 'd-flex', 'align-items-center', 'justify-content-between', 'gap-2']">
                        <div class="d-flex flex-column align-items-stretch gap-2 w-100">
                            <h5 v-if="modalMode == 'statisticCardCity'" class="large-text extra-black-color font-weight-600 text-start">ქალაქების ჩამონათვალი</h5>
                            <h5 v-if="modalMode == 'statisticCardRegion'" class="large-text extra-black-color font-weight-600 text-start">უბნების ჩამონათვალი</h5>
                            <h5 v-if="modalMode == 'statisticCardProblem'" class="large-text extra-black-color font-weight-600 text-start">პრობლემების ჩამონათვალი</h5>
                            <div class="common-table-container common-scrollbar common-vertical-overflow">
                                <table class="common-tablee">
                                    <thead>
                                        <tr>
                                            <th class="light-text light-blue-color text-start">
                                                <p>დასახელება</p>
                                            </th>
                                            <th class="light-text light-blue-color">
                                                <p>რაოდენობა</p>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody id="modal-left-report-body" class="common-scrollbar common-vertical-overflow">
                                        <template v-if="problemStatisticDetailedInfo?.mostProblematicCityList?.length > 0 && modalMode == 'statisticCardCity'">
                                            <tr v-for="(data, i) of problemStatisticDetailedInfo.mostProblematicCityList" @click="detailedProblemsByCityOrRegion(true, data.cityID), manageReportTrColoring($event, i)" class="light-black-color light-text">
                                                <td class="text-start"><p>{{ data.city }}</p></td>
                                                <td><p>{{ data.usr_pr_count }}</p></td>
                                            </tr>
                                        </template>
                                        <template v-if="problemStatisticDetailedInfo?.mostProblematicRegionList?.length > 0 && modalMode == 'statisticCardRegion'">
                                            <tr v-for="(data, i) of problemStatisticDetailedInfo.mostProblematicRegionList" @click="detailedProblemsByCityOrRegion(false, data.regionID), manageReportTrColoring($event, i)" class="light-black-color light-text">
                                                <td class="text-start"><p>{{ data.region }}</p></td>
                                                <td><p>{{ data.usr_pr_count }}</p></td>
                                            </tr>
                                        </template>
                                        <template v-if="problemStatisticDetailedInfo?.mostProblematicTypeCountList?.length > 0 && modalMode == 'statisticCardProblem'">
                                            <tr v-for="(data, i) of problemStatisticDetailedInfo.mostProblematicTypeCountList" @click="cityAndRegionByProblemType(data.problem_typeID), manageReportTrColoring($event, i)" class="light-black-color light-text">
                                                <td class="text-start"><p>{{ data.problem_type }}</p></td>
                                                <td><p>{{ data.sum_pr }} {{ data.problem_statusID }}</p></td>
                                            </tr>
                                        </template>
                                        <template v-if="problemStatisticDetailedFilteredInfo?.mostProblematicTypeCountList?.length > 0 && modalMode == 'statisticCardProblemFiltered'">
                                            <tr v-for="(data, i) of problemStatisticDetailedFilteredInfo.mostProblematicTypeCountList" class="light-black-color light-text">
                                                <td class="text-start"><p>{{ data.problem_type }}</p></td>
                                                <td><p>{{ data.sum_pr }}</p></td>
                                            </tr>
                                        </template>
                                        <template v-if="problemStatisticDetailedFilteredInfo?.mostProblematicOveralCountByType?.length > 0 && modalMode == 'statisticCardOverallProblemStatuses'">
                                            <tr v-for="(data, i) of problemStatisticDetailedFilteredInfo.mostProblematicOveralCountByType" class="light-black-color light-text">
                                                <td :class="['light-text', {'extra-red-color': data.problem_statusID == 1}, {'extra-orange-color': data.problem_statusID == 2}, {'extra-green-color': data.problem_statusID == 3}, 'text-start']"><p>{{ data.problem_statuse }}</p></td>
                                                <td><p>{{ data.sum_count }}</p></td>
                                            </tr>
                                        </template>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div v-if="modalMode == 'statisticCardCity' || modalMode == 'statisticCardRegion' || modalMode == 'statisticCardProblem'" class="d-flex flex-column align-items-stretch gap-2 w-100">
                            <h5 v-if="modalMode == 'statisticCardProblem'" class="large-text extra-black-color font-weight-600 text-start">ქალაქების ჩამონათვალი</h5>
                            <h5 v-else class="large-text extra-black-color font-weight-600 text-start">პრობლემების ჩამონათვალი</h5>
                            <div class="common-table-container common-scrollbar common-vertical-overflow">
                                <table class="common-tablee">
                                    <thead>
                                        <tr>
                                            <th class="light-text light-blue-color text-start">
                                                <p>დასახელება</p>
                                            </th>
                                            <th class="light-text light-blue-color">
                                                <p>რაოდენობა</p>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="common-scrollbar common-vertical-overflow">
                                        <template v-if="problemStatisticDetailedSecondaryInfo?.length > 0 && modalMode == 'statisticCardCity'">
                                            <tr v-for="(data, i) of problemStatisticDetailedSecondaryInfo" class="light-black-color light-text">
                                                <td class="text-start"><p>{{ data.problem_type }}</p></td>
                                                <td><p>{{ data.counts }}</p></td>
                                            </tr>
                                        </template>
                                        <template v-if="problemStatisticDetailedSecondaryInfo?.length > 0 && modalMode == 'statisticCardRegion'">
                                            <tr v-for="(data, i) of problemStatisticDetailedSecondaryInfo" class="light-black-color light-text">
                                                <td class="text-start"><p>{{ data.problem_type }}</p></td>
                                                <td><p>{{ data.counts }}</p></td>
                                            </tr>
                                        </template>
                                        <template v-if="problemStatisticDetailedSecondaryInfo?.length > 0 && modalMode == 'statisticCardProblem'">
                                            <tr v-for="(data, i) of problemStatisticDetailedSecondaryInfo" class="light-black-color light-text">
                                                <td class="text-start"><p>{{ data.city }}</p></td>
                                                <td><p>{{ data.counts }}</p></td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </primaryModalComponent>
</template>
<script>
import commonStatisticsBlock from "@/components/commonStatisticsBlock.vue"
import searchFilterBarComponent from "@/components/search-filterBarComponent.vue"
import commonCardAccordion from "@/components/commonCardAccordion.vue"
import markerMapComponent from "@/components/markerMapComponent.vue";
import Multiselect from "@vueform/multiselect";
import primaryModalComponent from "@/components/primaryModalComponent.vue";
import mediaShowDownload from "@/components/mediaShowDownload.vue";
import excelFileDownloadComponent from "@/components/excelFileDownloadComponent.vue";
import commonStatisticsBarChart from "@/components/commonStatisticsBarChart.vue"
import primaryButtonComponent from "@/components/primaryButtonComponent.vue";
import fileUpload from "@/components/fileUpload.vue"
import datePicker from "@/components/datePicker.vue";
import store from "@/store";

export default {
    data(){
        return {
            // for filters >>
            activatedFilterMode: 0,
            filteringPagingInfo: {
                problemssearch: "",
                problemscityID: null,
                problemsregionID: null,
                problemsdistrictID: null,
                problemsproblemTypeIDs: null,
                problemsOffset: null,
                problemsstartDateInputValue: null,
                problemsendDateInputValue: null,
                problemsuser_problemID: null,
                problemsseen: null,
                problemsstatus: null,
            },
            // for problems filters >>
            problemsFiltersInfoObj: {
                search: null,
                cityID:null,
                regionID: null,
                districtID:null,
                problemTypeIDs: null,
                seen: null,
                status: null,
                date: [],
                startDateInputValue: null,
                endDateInputValue: null,
                user_problemID: null,
            },
            problemsFiltersMultiselectsArray: [
                {},
                {
                    placeholder: "ოლქი",
                    options: [],
                    mode: "single",
                    getterEndpoint: "getCities",
                    isDisabled: false,
                },
                {
                    placeholder: "უბანი",
                    options: [],
                    mode: "single",
                    getterEndpoint: "getRegions",
                    isDisabled: true,
                },
                {
                    placeholder: "უბნის ნომერი",
                    options: [],
                    mode: "single",
                    getterEndpoint: "getDistricts",
                    isDisabled: true,
                },
            ],
            problemTypeSortMultiselectArray: [
                {
                    placeholder: "პრობლემის ტიპი",
                    options: [],
                    mode: "multiple",
                    isDisabled: false,
                }
            ],
            seentMultiselectArray: [
                {
                    placeholder: "ნანახი",
                    options: [
                        {
                            value: 1,
                            label: {
                                ge: "კი",
                                en: "yes"
                            }
                        },
                        {
                            value: 0,
                            label: {
                                ge: "არა",
                                en: "no"
                            }
                        }
                    ],
                    mode: "single",
                    isDisabled: false,
                }
            ],
            problemFiltersStatusesMultiselectArray: [
                {
                    placeholder: "სტატუსი",
                    options: [],
                    mode: "multiple",
                    isDisabled: false,
                }
            ],
            problemSearchMultiselectArray: [
                {
                    placeholder: "ძებნა",
                    options: [],
                    mode: "multiple",
                    isDisabled: false,
                }
            ],
            problemsPagingInfo: {
                limit: 8,
                offset: 1,
                total: 0,
            },
            // << for filters

            // for problem statistic cards >>
            problemStatisticsInfo: null,
            problemStatisticDetailedInfo: null, // object do not need set value in triggerModal
            problemStatisticDetailedSecondaryInfo: [],
            checkedElementInModalReport: null,
            problemStatisticDetailedFilteredInfo: null, // object do not need set value in triggerModal
            // << for problem statistic cards


            isAccordionOpened: false,
            indexOfOpenedAccordion: null,
            accordionCloseTrigger: false,

            isSending: false,
            openedProblemObj: null,
            openedProblemFile: null,
            problemObjForAdditionalCommentVmodel: null,
            problemsArray: [],
            markerInfoArray: [],
            markerMapCurrentCenter: {},
            unzoomMapLevel: 0,
            zoomedMarkerIndex: null,
            
            // for modal >>
            showModal: false,
            modalMode: null,
            modalTitle: "",
            modalSubTitle: "",
            // for photo section >>
            photoUrl: null,
            photoDownloadName: null,
            // for audio section >>
            audioURL: null,
            audioAbortController: null,
            // for video section >>
            videoAbortController: null,
            videoURL: null,
            // for problemstatus in modal>>
            problemStatusesMultiselectArray: [
                {
                    placeholder: "სტატუსი",
                    options: [],
                    mode: "single",
                    isDisabled: false,
                    vmodel: null,
                },
            ],
            // for problem edit >>
            editProblemVmodels: null,
            photoFilesArrayForProblemEdit: [],
            videoFilesArrayForProblemEdit: [],
            audioFilesArrayForProblemEdit: [],
            filesEmptierForProblemEdit: false,
            problemTypesMultiselectArray: [
                {
                    placeholder: "პრობლემის ტიპი",
                    options: [],
                    mode: "single",
                    isDisabled: false,
                },
            ],
            editProblemAreaVmodelsMultiselectsArray: [
                {},
                {
                placeholder: "ოლქი",
                options: [],
                mode: "single",
                isDisabled: false,
                },
                {
                placeholder: "უბანი",
                options: [],
                mode: "single",
                isDisabled: true,
                },
            ],



            // for problems excel download >> 
            problemsJsonToExcelArray: [],
            problemsExcelDownloadAbortController: null,
            problemsDownloadInAction: false,
        }
    },
    components: {
        commonStatisticsBlock,
        searchFilterBarComponent,
        commonCardAccordion,
        markerMapComponent,
        Multiselect,
        primaryModalComponent,
        mediaShowDownload,
        excelFileDownloadComponent,
        commonStatisticsBarChart,
        primaryButtonComponent,
        fileUpload,
        datePicker,
    },
    mounted(){
        this.routerMountMovement(this.$route);
        this.removeAriaHidden();
        this.$watch(() => this.problemsFiltersMultiselectsArray[1].options, (newOptions, oldOptions) => {
            this.problemsFiltersInfoObj.cityID = this.problemsFiltersInfoObj.cityID;
            
            if(this.problemsFiltersInfoObj.cityID){
                this.allowNextMultiselect(this.problemsFiltersInfoObj.cityID, 2, false, false, this.problemsFiltersMultiselectsArray, this.problemsFiltersInfoObj);
                
            }
        },
        { deep: true }
        );
        this.$watch(() => this.problemsFiltersMultiselectsArray[2].options, (newOptions, oldOptions) => {
            this.problemsFiltersInfoObj.regionID = this.problemsFiltersInfoObj.regionID;
            // if(this.problemsFiltersInfoObj.regionID){
            //     this.allowNextMultiselect(this.problemsFiltersInfoObj.regionID, 3, false, false, this.problemsFiltersMultiselectsArray, this.problemsFiltersInfoObj);
            // }
        },
        { deep: true }
        );
        // this.$watch(() => this.problemsFiltersMultiselectsArray[3].options, (newOptions, oldOptions) => {
        //     this.problemsFiltersInfoObj.regionID = this.problemsFiltersInfoObj.regionID;
        // },
        // { deep: true }
        // );

        // for modal areal multiselects >>
        
    },
    watch:{
        'editProblemVmodels.cityID'(newVal){
            if(newVal){
                this.allowNextMultiselect(this.editProblemVmodels.cityID, 2, false, false, this.editProblemAreaVmodelsMultiselectsArray, this.editProblemVmodels);
            }
        }
    },
    beforeRouteUpdate(to, from, next){
        let isQueriesValid = this.getInfoFromRoute(to);
        
        if(isQueriesValid){
            if(this.activatedFilterMode == 0){
                this.manageProblemsFilters();
            }else if(this.activatedFilterMode == 1 || this.activatedFilterMode == 2){
                this.manageProblemsFilters();
            }
            next(true);
        }else{
            next(false);
            this.$helper.showSwal("არასწორი მისამართი", "error", "");
        }
        this.activatedFilterMode = 0;
    },
    methods: {
        routerMountMovement(to){
            let isQueriesValid = this.getInfoFromRoute(to);
        
            if(isQueriesValid){
                this.getCitiesAll([this.problemsFiltersMultiselectsArray, this.editProblemAreaVmodelsMultiselectsArray]);
                this.manageProblemsFilters();
                this.getProblemTypes();
                this.getProblemStatuses();
                this.getUserProblemIdentifiers();

            }else{
                this.$router.replace(this.$route.path);
                this.$helper.showSwal("არასწორი მისამართი", "error", "");
            }
            this.activatedFilterMode = 0;
        },
        getInfoFromRoute(to){
            Object.keys(this.filteringPagingInfo).forEach((key) => {
                this.filteringPagingInfo[key] = to.query[key]?decodeURIComponent(to.query[key]):null;
            })
            
            
            let isQueriesValid = Object.keys(this.filteringPagingInfo).every((key) => {
                if(key == "problemssearch" || key == "problemsstartDateInputValue" || key == "problemsendDateInputValue" || key == "problemsproblemTypeIDs" || key == "problemsstatus"){
                    return this.$helper.checkJustOptionalString(this.filteringPagingInfo[key]);
                }else if(this.filteringPagingInfo[key] == null){
                    return true;
                }else{
                    return this.$helper.checkOptionalNumber(this.filteringPagingInfo[key]);
                }
            });
            
            return isQueriesValid;
        },
        getPhotosForProblemEdit(filesArray){
            this.photoFilesArrayForProblemEdit = filesArray;
        },
        getVideosForProblemEdit(filesArray){
            this.videoFilesArrayForProblemEdit = filesArray;
        },
        getAudiosForProblemEdit(filesArray){
            this.audioFilesArrayForProblemEdit = filesArray;
        },
        async editProblem(){
            this.isSending = true;
            let tempObj = {
                ...this.editProblemVmodels,
                user_problemID: this.openedProblemObj.user_problemID,
                input_date: new Date().toLocaleString("sv-SE"),
                lat: this.openedProblemObj.lat,
                lng: this.openedProblemObj.lng,
                problem_typeID: [this.editProblemVmodels.problem_typeID],
            };
            await Promise.all([this.$store.dispatch("editUserProblems", {...tempObj}), ...this.getValideRequestsForEdit(this.photoFilesArrayForProblemEdit),
                ...this.getValideRequestsForEdit(this.videoFilesArrayForProblemEdit), ...this.getValideRequestsForEdit(this.audioFilesArrayForProblemEdit)
            ]).then((response) => {
                this.isSending = false;
                this.$helper.showSwal("პრობლემა წარმატებით ჩასწორდა", "success", "");
                setTimeout(() => {
                    this.triggerModal(false);
                }, 1500);
                if(this.problemsFiltersInfoObj.user_problemID){
                    this.getDetailedProblemByProblemID();
                }else{
                    this.getUserProblems(false);
                }
                this.getProblemStatistic();
                this.getProblemStatisticDetailedWithOrWithoutFilters(false);
                this.getProblemStatisticDetailedWithOrWithoutFilters(true);
                this.getAllUserProblems();
            }).catch((error) => {
                
                if(error.response.status >= 400){
                    this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                    this.isSending = false;
                    setTimeout(() => {
                        this.triggerModal(false);
                    }, 1500);
                    if(this.problemsFiltersInfoObj.user_problemID){
                        this.getDetailedProblemByProblemID();
                    }else{
                        this.getUserProblems(false);
                    }
                    this.getProblemStatistic();
                    this.getProblemStatisticDetailedWithOrWithoutFilters(false);
                    this.getProblemStatisticDetailedWithOrWithoutFilters(true);
                    this.getAllUserProblems();
                }
            });
        },
        getValideRequestsForEdit(filesArray){
            if(filesArray.length > 0){
                return Array.from(filesArray).flatMap((file) => {
                    if(file.type.startsWith("image")){
                        return this.$store.dispatch("addUserProblemsMedia", {problemPhoto: file, user_problemID: this.openedProblemObj.user_problemID});
                    }else if(file.type.startsWith("video")){
                        return this.$store.dispatch("addUserProblemsMedia", {problemVideo: file, user_problemID: this.openedProblemObj.user_problemID});
                    }else if(file.type.startsWith("audio")){
                        return this.$store.dispatch("addUserProblemsMedia", {problemAudio: file, user_problemID: this.openedProblemObj.user_problemID});
                    }
                })
            }else{
                return [];
            }
        },
        statusChangeClickHandler(problemObj){
            this.fillOpenedProblemObj(problemObj);
            this.problemStatusesMultiselectArray[0].vmodel = problemObj.problem_status.problem_statusID;
            this.activateModalMode('changeStatus', true);
        },
        editClickHandler(problemObj){
            this.fillOpenedProblemObj(problemObj);
            this.editProblemVmodels = {
                problem_typeID: problemObj.problem_typeID,
                // input_date: problemObj.input_date,
                comment: problemObj.comment,
                cityID: problemObj.cityID,
                regionID: problemObj.regionID,
                address: problemObj.address,
            };
            
            this.activateModalMode('editProblem', true);
        },
        deleteClickHandler(problemObj){
            this.fillOpenedProblemObj(problemObj);
            this.activateModalMode('deleteProblem', true);
        },
        deleteProblem(){
            this.isSending = true;
            this.$store.dispatch("deleteUserProblem", {user_problemID: this.openedProblemObj.user_problemID}).then((response) => {
                if(response.status == 200){
                    this.$helper.showSwal("პრობლემა წარმატებით წაიშალა", "success", "");
                    this.isSending = false;
                    setTimeout(() => {
                        this.triggerModal(false);
                    }, 1500);

                    if(this.problemsFiltersInfoObj.user_problemID){
                        this.paginationClickHandler(1);
                    }else{
                        this.getUserProblems(true);
                        this.getProblemStatistic();
                        this.getProblemStatisticDetailedWithOrWithoutFilters(false);
                        this.getProblemStatisticDetailedWithOrWithoutFilters(true);
                        this.getAllUserProblems();
                    }

                }
            }).catch((error) => {
                if(error.response.status >= 400){
                    this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                    this.isSending = false;
                    this.triggerModal(false);
                }
            });
        },
        addAdditionalComment(){
            if(this.problemObjForAdditionalCommentVmodel && this.openedProblemObj.vizireba !== this.problemObjForAdditionalCommentVmodel){
                this.isSending = true;
                this.$store.dispatch("setAdditionalComment", {user_problemID: this.openedProblemObj.user_problemID,
                    vizireba: this.problemObjForAdditionalCommentVmodel,
                }).then((response) => {
                    if(response.status == 200){
                        this.$helper.showSwal("კომენტარი წარმატებით დაემატა", "success", "");
                        this.isSending = false;
                        setTimeout(() => {
                            this.triggerModal(false);
                        }, 1500);
                        if(this.problemsFiltersInfoObj.user_problemID){
                            this.getDetailedProblemByProblemID();
                        }else{
                            this.getUserProblems(false);
                        }
                        this.getProblemStatistic();
                        this.getProblemStatisticDetailedWithOrWithoutFilters(false);
                        this.getProblemStatisticDetailedWithOrWithoutFilters(true);
                        this.getAllUserProblems();
                    }
                }).catch((error) => {
                    if(error.response.status >= 400){
                        this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                        this.isSending = false;
                        this.triggerModal(false);
                    }
                    // this.accordionCloseTrigger = !this.accordionCloseTrigger;
                    // this.isAccordionOpened = false;
                    // this.indexOfOpenedAccordion = null;
                }).finally(() => {
                    this.isSending = false;
                });
            }
        },
        fillOpenedProblemObj(problemObj){
            this.openedProblemObj = {...problemObj};
            this.openedProblemObj.photoCount = problemObj.problem_files.reduce((accumulator, problemObj) => {
                return (problemObj.file_type == 1)?++accumulator:accumulator;
            }, 0);
            this.openedProblemObj.videoCount = problemObj.problem_files.reduce((accumulator, problemObj) => {
                return (problemObj.file_type == 2)?++accumulator:accumulator;
            }, 0);
            this.openedProblemObj.audioCount = problemObj.problem_files.reduce((accumulator, problemObj) => {
                return (problemObj.file_type == 3)?++accumulator:accumulator;
            }, 0);
        },
        additionalCommentClickHandler(modalMode, isOpen, problemObj){
            this.activateModalMode(modalMode, isOpen);
            this.fillOpenedProblemObj(problemObj);
            // this.problemObjForAdditionalCommentVmodel = problemObj.vizireba;
            this.problemObjForAdditionalCommentVmodel = null;
        },
        getProblemStatistic(){ // static, filters does not work
            this.$store.dispatch("getProblemStatistic", {...this.problemsFiltersInfoObj}).then((response) => {
                this.problemStatisticsInfo = response.data;
            });
        },
        getProblemStatisticDetailedWithOrWithoutFilters(useFilters){
            this.$store.dispatch("getProblemStatisticDetailed", useFilters?{...this.problemsFiltersInfoObj}:{}).then((response) => {
                // this.problemStatisticDetailedInfo = response.data;
                let resultOverallCountByType = {};

                response.data.mostProblematicOveralCountByType.forEach((overallCountByTypeObj) => {
                    if(resultOverallCountByType[overallCountByTypeObj.problem_statusID]){
                        resultOverallCountByType[overallCountByTypeObj.problem_statusID].sum_count += Number(overallCountByTypeObj.sum_count);
                    }else{
                        resultOverallCountByType[overallCountByTypeObj.problem_statusID] = {
                            sum_count: Number(overallCountByTypeObj.sum_count),
                            problem_statuse: overallCountByTypeObj.problem_statuse,
                            problem_statusID: overallCountByTypeObj.problem_statusID,
                        }
                    }
                })
                
                response.data.mostProblematicOveralCountByType = Object.values(resultOverallCountByType);
                
                response.data.mostProblematicOveralCountByType.sort((a, b) => {
                    return a.problem_statusID - b.problem_statusID;
                });




                let resultMostProblematicTypeCountList = {};
                response.data.mostProblematicTypeCountList.forEach((mostProblematicTypeCountObj) => {
                    if(resultMostProblematicTypeCountList[mostProblematicTypeCountObj.problem_typeID]){
                        resultMostProblematicTypeCountList[mostProblematicTypeCountObj.problem_typeID].sum_pr += Number(mostProblematicTypeCountObj.sum_pr);
                    }else{
                        resultMostProblematicTypeCountList[mostProblematicTypeCountObj.problem_typeID]= {
                            sum_pr: Number(mostProblematicTypeCountObj.sum_pr),
                            problem_type: mostProblematicTypeCountObj.problem_type,
                            problem_typeeng: mostProblematicTypeCountObj.problem_typeeng,
                            problem_typeID: mostProblematicTypeCountObj.problem_typeID,
                        };
                    }
                });
                response.data.mostProblematicTypeCountList = Object.values(resultMostProblematicTypeCountList);
                response.data.mostProblematicTypeCountList.sort((a, b) => {
                    return b.sum_pr - a.sum_pr;
                });
                if(useFilters){
                    this.problemStatisticDetailedFilteredInfo = response.data;
                }else{
                    this.problemStatisticDetailedInfo = response.data;
                }
            
            });
        },
        changeStatusHandler(){
            this.isSending = true;
            this.$store.dispatch("setProblemStatus", {user_problemID: this.openedProblemObj.user_problemID, 
                problem_statusID: this.problemStatusesMultiselectArray[0].vmodel,
            }).then((response) => {
                if(response.status == 200){
                    this.$helper.showSwal("სტატუსი წარმატებით განახლდა", "success", "");
                    this.isSending = false;
                    setTimeout(() => {
                        this.triggerModal(false);
                    }, 1500);
                    if(this.problemsFiltersInfoObj.user_problemID){
                        this.getDetailedProblemByProblemID();
                    }else{
                        this.getUserProblems(false);
                    }
                    this.getProblemStatistic();
                    this.getProblemStatisticDetailedWithOrWithoutFilters(false);
                    this.getProblemStatisticDetailedWithOrWithoutFilters(true);
                    this.getAllUserProblems();
                }
            }).catch((error) => {
                if(error.response.status >= 400){
                    this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                    this.isSending = false;
                    this.triggerModal(false);
                }
            });
        },
        getProblemStatuses(){
            this.$store.dispatch("getProblemStatuses").then((response) => {
                let tempArray = [];
                response.data.forEach((problemStatusObj) => {
                    tempArray.push({
                        value: problemStatusObj.problem_statusID,
                        label: {
                            ge: problemStatusObj.problem_statuse,
                            en: problemStatusObj.problem_statuseeng,
                        }
                    });
                });

                this.problemStatusesMultiselectArray[0].options = tempArray;
                this.problemFiltersStatusesMultiselectArray[0].options = tempArray;
            });
        },
       
        getUserProblems(closeCard){
            
            let cutomDateRange = null;
            if(this.problemsFiltersInfoObj.startDateInputValue && this.problemsFiltersInfoObj.endDateInputValue){
                let customDate = this.$helper.getNextDay(this.problemsFiltersInfoObj.endDateInputValue);
                
                customDate = `${customDate.getFullYear()}-${String(customDate.getMonth() + 1).padStart(2, '0')}-${String(customDate.getDate()).padStart(2, '0')}`;
                
                cutomDateRange = `${this.problemsFiltersInfoObj.startDateInputValue}_${customDate}`;
            }
            
            this.$store.dispatch("getUserProblems", {...this.problemsFiltersInfoObj, cutomDateRange, 
                offset: this.problemsPagingInfo.offset - 1, limit: this.problemsPagingInfo.limit, signal: null}).then((response) => {
                this.problemsArray = response.data[0];
                // this.problemsArray = response.data.filter((problemObj) => {
                //     return problemObj.problem_files.length > 0;
                // });
                
                
                this.problemsPagingInfo.total = response.data[1];
                
                if(closeCard){
                    this.accordionCloseTrigger = !this.accordionCloseTrigger;
                    this.isAccordionOpened = false;
                    this.indexOfOpenedAccordion = null;
                    this.zoomOnIndexMarker(null);
                }
                
            })
            
        },
        getAllUserProblems(){
            let cutomDateRange = null;
            if(this.problemsFiltersInfoObj.startDateInputValue && this.problemsFiltersInfoObj.endDateInputValue){
                cutomDateRange = `${this.problemsFiltersInfoObj.startDateInputValue}_${this.problemsFiltersInfoObj.endDateInputValue}`;
            }
            this.$store.dispatch("getUserProblemLocations", {...this.problemsFiltersInfoObj, cutomDateRange, 
                offset: 0, limit: Number.MAX_SAFE_INTEGER, signal: null}).then((response) => {

                let tempArray = [];
                for(let problem of response.data){
                    if(problem.lat != null){
                        tempArray.push({
                            name: (problem?.problem_type?.problem_type)?problem.problem_type.problem_type:"",
                            latLng: {
                                lat: Number(problem.lat),
                                lng: Number(problem.lng),
                                altitude: 0,
                            },
                            address: `address: ${problem.address}`,
                            comment: `comment: ${problem.comment}`,
                            ID: problem.user_problemID,
                        });
                    }
                }
                this.markerInfoArray = tempArray;
            });
        },
        getProblemTypes(){
            this.$store.dispatch("getProblemTypes").then((response) => {
                let tempArray = [];
                response.data.forEach((problemTypeObj) => {
                    tempArray.push({
                        value: problemTypeObj.problem_typeID,
                        label: {
                            ge: problemTypeObj.problem_type,
                            en: problemTypeObj.problem_typeeng,
                        },
                    });
                });

                this.problemTypeSortMultiselectArray[0].options = tempArray;
                this.problemTypesMultiselectArray[0].options = tempArray;
            });
        },
        getUserProblemIdentifiers(){
            this.$store.dispatch("getUserProblemIdentifiers").then((response) => {
                let tempArray = [];
                response.data.forEach((problemIdentifierObj) => {
                    tempArray.push({
                        value: problemIdentifierObj.userID,
                        label: {
                            ge: `${problemIdentifierObj.name} ${problemIdentifierObj.surename} - ${problemIdentifierObj.phone}`,
                            en: `${problemIdentifierObj.name} ${problemIdentifierObj.surename} - ${problemIdentifierObj.phone}`,
                        },
                    });
                });

                this.problemSearchMultiselectArray[0].options = tempArray;
            });
        },
        problemsIgniteDownload(){
            this.problemsJsonToExcelArray = [];
            let firstArray = [];
            this.problemsExcelDownloadAbortController = new AbortController();
            let cutomDateRange = null;
            if(this.problemsFiltersInfoObj.startDateInputValue && this.problemsFiltersInfoObj.endDateInputValue){
                cutomDateRange = `${this.problemsFiltersInfoObj.startDateInputValue}_${this.problemsFiltersInfoObj.endDateInputValue}`;
            }
            this.$store.dispatch("getUserProblems", {...this.problemsFiltersInfoObj, cutomDateRange, 
                offset: 0, limit: Number.MAX_SAFE_INTEGER, signal: this.problemsExcelDownloadAbortController.signal}).then((response) => {
                firstArray.push([
                    "პრობლემის ტიპი",
                    "ქალაქი",
                    "უბანი",
                    "მისამართი",
                    "კომენტარი",
                    "ვიზირება",
                    "განმცხადებლის სახელი",
                    "განმცხადებლის გვარი",
                    "განმცხადებლის პირადი ნომერი",
                    "განმცხადებლის ტელეფონის ნომერი",
                    "თანამშრომლის სახელი",
                    "თანამშრომლის გვარი",
                    "თანამშრომლის ტელეფონის ნომერი",
                    "დამატების თარიღი",
                ]);
                
                response.data[0].forEach((problemObj) => {


            
                    let vizireba =  problemObj.vizireba.reduce((accumulator, vizirebaObj) => {
                        return `${accumulator}${vizirebaObj.add_date}-${vizirebaObj.vizireba};\n`;
                    }, "")
                    firstArray.push([
                        `${problemObj?.problem_type?.problem_type??"უცნობია"}`,
                        `${problemObj?.city?.city??"უცნობია"}`,
                        `${problemObj?.region?.region??"უცნობია"}`,
                        `${problemObj?.address??"უცნობია"}`,
                        `${problemObj?.comment??""}`,
                        `${vizireba}`,
                        `${problemObj?.respodent?.name??"უცნობია"}`,
                        `${problemObj?.respodent?.surename??"უცნობია"}`,
                        `${problemObj?.respodent?.personal_number??"უცნობია"}`,
                        `${problemObj?.respodent?.phone??"უცნობია"}`,
                        `${problemObj?.user?.name??"უცნობია"}`,
                        `${problemObj?.user?.surename??"უცნობია"}`,
                        `${problemObj?.user?.phone??"უცნობია"}`,
                        `${problemObj?.input_date??"უცნობია"}`,
                    ]);
                });
                
                this.problemsJsonToExcelArray.push(firstArray);
                this.problemsDownloadInAction = !this.problemsDownloadInAction;
            }).catch((error) => {
                if(error.message == "canceled"){
                }
            }).finally(() => {
                this.problemsExcelDownloadAbortController = null;
            });

        },
        problemsExcelDownloadAbort(){
            
            this.problemsExcelDownloadAbortController?.abort();
            this.problemsExcelDownloadAbortController = null;
        },
        zoomOnIndexMarker(index){
            this.zoomedMarkerIndex = index;
        },
        openAccordionOnIndex(index, id){
            this.indexOfOpenedAccordion = index;
            this.isAccordionOpened = true;

            if(this.problemsArray[index].seen == 0){
                this.$store.dispatch("seenUserProblem", {user_problemID: id}).then((response) => {
                    this.problemsArray[index].seen = 1;
                }).catch(() => {
                });
            }
            
            let foundIndex = this.markerInfoArray.findIndex((markerObj) => {
                return markerObj.ID == id;
            });


            this.zoomOnIndexMarker(foundIndex);
            if(this.markerInfoArray[foundIndex].latLng.lat){
                this.markerMapCurrentCenter = {lat: this.markerInfoArray[foundIndex].latLng.lat, lng: this.markerInfoArray[foundIndex].latLng.lng};
            }else{
                this.markerMapCurrentCenter = {};
            }
            this.unzoomMapLevel = 12;
        },
        closeAccordionOnIndex(index){
            this.indexOfOpenedAccordion = null;
            this.isAccordionOpened = false;
            this.zoomOnIndexMarker(null);
        },
        paginationClickHandler(value){
            this.activatedFilterMode = 1;
            let tempObj = {...this.$route.query};
            delete tempObj.problemsuser_problemID;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...tempObj,
                    problemsOffset: value - 1,
                }
            });
        },
        handleDate(modelDate){
            if(modelDate){
                this.problemsFiltersInfoObj.startDateInputValue = modelDate[0]??null;
                if(modelDate.length > 1){
                    this.problemsFiltersInfoObj.endDateInputValue = modelDate[1];

                }else{
                    this.problemsFiltersInfoObj.endDateInputValue = null;
                }
            }else{
                this.problemsFiltersInfoObj.startDateInputValue = null;
                this.problemsFiltersInfoObj.endDateInputValue = null;
            }
            
        },
        format(dates){
            let startday, startmonth, startyear;
            let endday, endmonth, endyear;
            if(dates?.length > 0){
                startday = dates[0].getDate();
                startmonth = dates[0].getMonth() + 1;
                startyear = dates[0].getFullYear();
            }
            if(dates?.length > 1){
                endday = dates[1].getDate();
                endmonth = dates[1].getMonth() + 1;
                endyear = dates[1].getFullYear();
            }
            let startStr = startday?`${startday}-${startmonth}-${startyear}`:"";
            let endStr = endday?` : ${endday}-${endmonth}-${endyear}`:"";

            return `${startStr}${endStr}`;
        },
        getProblemVideo(file_name, user_problemID, problemObj, problemFile){
            this.videoAbortController = new AbortController();
            this.videoURL = null;
            this.$store.dispatch("getProblemVideo", {file_name, user_problemID, signal: (this?.videoAbortController?.signal)??null}).then((response) => {
                let videoBlob = new Blob([response.data], {type: "video/mp4"});
                this.videoURL = URL.createObjectURL(videoBlob);
            }).catch((error) => {
                if (error.code === 'ERR_CANCELED') {
                } else {
                }
            });
            this.fillOpenedProblemObj(problemObj);
            this.openedProblemFile = problemFile;
        },
        getProblemAudio(file_name, user_problemID, problemObj, problemFile){
            this.audioAbortController = new AbortController();
            this.audioURL = null;
            this.$store.dispatch("getProblemAudio", {file_name, user_problemID, signal: (this?.audioAbortController?.signal)??null}).then((response) => {
                let audioBlob = new Blob([response.data], {type: "audio/wav"});
                // audio/wav
                // audio/mpeg
                this.audioURL = URL.createObjectURL(audioBlob);
            }).catch((error) => {
                if (error.code === 'ERR_CANCELED') {
                } else {
                }
            });
            this.fillOpenedProblemObj(problemObj);
            this.openedProblemFile = problemFile;
        },
        manageProblemFiltersWithIDFromMap(id){
            this.activatedFilterMode = 2;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    problemsuser_problemID: id,
                    problemsOffset: 0,
                }
            });
            
        },
        manageProblemsFilters(){
            Object.keys(this.problemsFiltersInfoObj).forEach((key) => {
                if(key == "startDateInputValue" || key == "endDateInputValue"){
                    this.problemsFiltersInfoObj[key] = this.filteringPagingInfo[`problems${key}`];
                }else if(key == "date"){

                }else if(key == "problemTypeIDs" || key == "search" || key == "status"){
                    this.problemsFiltersInfoObj[key] = this.filteringPagingInfo[`problems${key}`]?this.filteringPagingInfo[`problems${key}`].split(";"):null;
                }
                else if(this.filteringPagingInfo[`problems${key}`]){
                    this.problemsFiltersInfoObj[key] = Number(this.filteringPagingInfo[`problems${key}`]);
                }else{
                    this.problemsFiltersInfoObj[key] = this.filteringPagingInfo[`problems${key}`];
                }
            })

            this.problemsFiltersInfoObj.date = this.problemsFiltersInfoObj.startDateInputValue?[this.problemsFiltersInfoObj.startDateInputValue??null, this.problemsFiltersInfoObj.endDateInputValue??null]:null;
            
            
            if(!this.problemsFiltersInfoObj.cityID){
                this.blockNextMultiselects(2, this.problemsFiltersMultiselectsArray, this.problemsFiltersInfoObj);
            }else if(!this.problemsFiltersInfoObj.regionID){
                this.blockNextMultiselects(3, this.problemsFiltersMultiselectsArray, this.problemsFiltersInfoObj);
            }

            if(this.problemsFiltersInfoObj.cityID){
                this.allowNextMultiselect(this.problemsFiltersInfoObj.cityID, 2, false, false, this.problemsFiltersMultiselectsArray, this.problemsFiltersInfoObj);
            }else if(this.problemsFiltersInfoObj.regionID){
                this.allowNextMultiselect(this.problemsFiltersInfoObj.cityID, 3, false, false, this.problemsFiltersMultiselectsArray, this.problemsFiltersInfoObj);
            }
            
            this.problemsPagingInfo.offset = this.filteringPagingInfo.problemsOffset?Number(this.filteringPagingInfo.problemsOffset) + 1:1;
            
            this.markerMapCurrentCenter = {};
            this.unzoomMapLevel = 0;

            let isMapMarkersFetched = false;
            if((this.activatedFilterMode == 1 || this.activatedFilterMode == 0) && !this.problemsFiltersInfoObj.user_problemID){
                this.getUserProblems(true);
                this.getProblemStatistic();
                this.getProblemStatisticDetailedWithOrWithoutFilters(false);
                this.getProblemStatisticDetailedWithOrWithoutFilters(true);
                this.getAllUserProblems();
                isMapMarkersFetched = true;
                
            }
            if(this.activatedFilterMode == 0 && !isMapMarkersFetched){
                this.getAllUserProblems();
            }
            if((this.activatedFilterMode == 2 || this.activatedFilterMode == 0) && this.problemsFiltersInfoObj.user_problemID){
                this.getDetailedProblemByProblemID();
            }
        },
        getDetailedProblemByProblemID(){
            this.$store.dispatch("getDetailedProblemByProblemID", {user_problemID: this.problemsFiltersInfoObj.user_problemID}).then((response) => {
                this.problemsArray = [];
                this.problemsArray.push(response.data);
                this.problemsPagingInfo.total = 1;
                this.isAccordionOpened = false;
                this.indexOfOpenedAccordion = null;
            });
        },
        resetProblemsFilters(){
            Object.keys(this.problemsFiltersInfoObj).forEach((key) => {
                this.problemsFiltersInfoObj[key] = null;
            })
            this.submitProblemsFilters();
        },
        submitProblemsFilters(){
            let tempObj = {};
            if(this.$route.query.problemsOffset){
                tempObj.problemsOffset = 0;
            }
            Object.keys(this.problemsFiltersInfoObj).forEach((key) => {
                if((key == "problemTypeIDs" || key == "search" || "status") && this.problemsFiltersInfoObj[key]?.length > 0){
                    tempObj[`problems${key}`] = this.problemsFiltersInfoObj[key].join(";");
                }else if((this.problemsFiltersInfoObj[key] || this.problemsFiltersInfoObj[key] === 0) && key != "date"){
                    tempObj[`problems${key}`] = this.problemsFiltersInfoObj[key];
                }
            })
            this.activatedFilterMode = 1;
            let filteredQueries = {};
            Object.keys(this.$route.query).forEach((queryKey) => {
                if(this.problemsFiltersInfoObj.hasOwnProperty(`${queryKey.slice(8)}`) && queryKey.startsWith("problems")){
                }else{
                    filteredQueries[queryKey] = this.$route.query[queryKey];
                }
            })
            delete tempObj.problemsuser_problemID;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...filteredQueries,
                    ...tempObj,
                }
            });
        },
        allowNextMultiselect(value, index, clear, blockNext, changingArray, filterVModelsArray){
            if(value){
                if(index == 1){
                this.getCities(value, clear, changingArray, filterVModelsArray);
                }else if(index == 2){
                this.getRegions(value, clear, changingArray, filterVModelsArray);
                }
                // else if(index == 3){
                // this.getDistricts(value, clear, changingArray, filterVModelsArray);
                // }
            }
            
            if(index < changingArray.length - 1 && blockNext){
                this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
            }
        },
        blockNextMultiselects(index, changingArray, filterVModelsArray){
          
          if(index >= changingArray.length){
            return;
          }
              
          changingArray[index].options = [];
          if(index == 1){
            filterVModelsArray.cityID = null;
            this.getCitiesAll([this.problemsFiltersMultiselectsArray]);
          }else if(index == 2){
            filterVModelsArray.regionID = null;
            changingArray[index].isDisabled = true;
          }
        //   else if(index == 3){
        //     filterVModelsArray.districtID = null;
        //     changingArray[index].isDisabled = true;
        //   }
          this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
        },
        getDistricts(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getDistricts",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                tempArray.push({
                    value: obj.districtID,
                    label: {
                        ge: obj.district,
                        en: obj.district,
                    },
                });
                }
                if(clear){
                    filterVModelsArray.districtID = null;
                }
                changingArray[3].options = tempArray;
                changingArray[3].isDisabled = false;
            })
        },
        getRegions(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getRegions",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                tempArray.push({
                    value: obj.regionID,
                    label: {
                        ge: `${obj.region} ${obj.pathID?`- ${obj.pathID}`:""}`,
                        en: `${obj.regioneng} ${obj.pathID?`- ${obj.pathID}`:""}`,
                    },
                });
                }
                if(clear){
                    filterVModelsArray.regionID = null;
                }
                changingArray[2].options = tempArray;
                changingArray[2].isDisabled = false;
            })
        },
        getCitiesAll(changingArray){
            this.$store.dispatch("getCitiesAll").then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                tempArray.push({
                    value: obj.cityID,
                    label: {
                        ge: `${obj.city} ${obj.pathID?`- ${obj.pathID}`:""}`,
                        en: `${obj.cityeng} ${obj.pathID?`- ${obj.pathID}`:""}`,
                    },
                });
                }
                changingArray.forEach((destArray) => {
                    destArray[1].options = tempArray;
                    destArray[1].isDisabled = false;
                })
                // changingArray[1].options = tempArray;
                // changingArray[1].isDisabled = false;
            })
        },
        getCities(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getCities",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.cityID,
                        label: {
                            ge: obj.city,
                            en: obj.cityeng,
                        },
                    });
                }
                if(clear){
                    filterVModelsArray.cityID = null;
                }
                changingArray[1].options = tempArray;
                changingArray[1].isDisabled = false;
            })
        },
        triggerModal(Val){
            if(Val == false){
                this?.audioAbortController?.abort();
                this?.videoAbortController?.abort();
                URL.revokeObjectURL(this.audioURL);
                URL.revokeObjectURL(this.videoURL);
                this.videoURL = null;
                this.audioURL = null;
                this.photoUrl = null;
                this.openedProblemObj = null;
                this.problemObjForAdditionalCommentVmodel = null;
                this.problemStatusesMultiselectArray[0].vmodel = null;
                this.editProblemVmodels = {};
                this.modalSubTitle = "";
                this.filesEmptierForProblemEdit = !this.filesEmptierForProblemEdit;
                this.openedProblemFile = null;
                this.checkedElementInModalReport = null;
                this.problemStatisticDetailedSecondaryInfo = [];
            }
            setTimeout(() => {
                this.showModal = Val;
                this.removeAriaHidden();
            }, 0);
        },
        photoClickHandler(photoUrl, photoDownloadName, problemObj, problemFile){
            this.photoUrl = photoUrl;
            this.photoDownloadName = photoDownloadName;
            this.activateModalMode("photo", true);
            this.fillOpenedProblemObj(problemObj);
            this.openedProblemFile = problemFile;
        },
        deleteProblemMediaFiles(){
            this.isSending = true;
            let keyWord = this.openedProblemFile.file_type == 1?'სურათი':(this.openedProblemFile.file_type == 2?'ვიდეო':'აუდიო მასალა');

            this.$store.dispatch("deleteProblemMediaFiles", {problem_fileID: this.openedProblemFile.problem_fileID, user_problemID: this.openedProblemFile.user_problemID,
                file_type: this.openedProblemFile.file_type,
            }).then((response) => {
                if(response.status == 200){
                    this.$helper.showSwal(`${keyWord} წარმატებით წაიშალა`, "success", "");
                    this.isSending = false;
                    setTimeout(() => {
                        this.triggerModal(false);
                    }, 1500);
                    if(this.problemsFiltersInfoObj.user_problemID){
                        this.getDetailedProblemByProblemID();
                    }else{
                        this.getUserProblems(false);
                    }
                    this.getProblemStatistic();
                    this.getProblemStatisticDetailedWithOrWithoutFilters(false);
                    this.getProblemStatisticDetailedWithOrWithoutFilters(true);
                    this.getAllUserProblems();
                }
            }).catch((error) => {
                if(error.response.status >= 400){
                    this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                    this.isSending = false;
                    this.triggerModal(false);
                }
            });
            
        },
        activateModalMode(modalMode, isOpen){
            if(modalMode == "video"){
                this.modalTitle = "ვიდეო მასალა";
            }else if(modalMode == "photo"){
                this.modalTitle = "ფოტო მასალა";
            }else if(modalMode == "audio"){
                this.modalTitle = "აუდიო მასალა";
            }else if(modalMode == "additionalComment"){
                this.modalTitle = "ვიზირება";
            }else if(modalMode == "deleteProblem"){
                this.modalTitle = "ნამდვილად გსურთ წაშლა?";
            }else if(modalMode == "editProblem"){
                this.modalTitle = "ჩაასწორეთ პრობლემა";
            }else if(modalMode == "changeStatus"){
                this.modalTitle = "შეცვალეთ სტატუსი";
            }else if(modalMode == "statisticCardCity"){
                this.modalTitle = "დეტალურად:";
                this.modalSubTitle = "ყველაზე პრობლემური ქალაქები";
            }else if(modalMode == "statisticCardRegion"){
                this.modalTitle = "დეტალურად:";
                this.modalSubTitle = "ყველაზე პრობლემური უბნები";
            }else if(modalMode == "statisticCardProblem" || modalMode == "statisticCardProblemFiltered"){
                this.modalTitle = "დეტალურად:";
                this.modalSubTitle = "ხშირად დასახელებული პრობლემები";
            }else if(modalMode == "statisticCardOverallProblemStatuses"){
                this.modalTitle = "დეტალურად:";
                this.modalSubTitle = "რაოდენობა";
            }
            this.modalMode = modalMode;
            this.triggerModal(isOpen);
        },
        removeAriaHidden(){
            Array.from(document.querySelectorAll('.multiselect span[aria-hidden]')).forEach((item) => {
                item.removeAttribute('aria-hidden');
            })
            Array.from(document.querySelectorAll('.multiselect .multiselect-search[aria-labelledby]')).forEach((item) => {
                item.removeAttribute('aria-labelledby');
            })
        },
        manageReportTrColoring(event, i){
            if(this.checkedElementInModalReport != null){
                this.checkedElementInModalReport.classList.remove("active");
            }
            let clickedElement = document.getElementById('modal-left-report-body').children[i];
            clickedElement.classList.add("active");
            this.checkedElementInModalReport = clickedElement;
        },
        detailedProblemsByCityOrRegion(cityOrRegion, ID){
            let paramObj = {};
            if(cityOrRegion){
                paramObj.cityID = ID;
            }else{
                paramObj.regionID = ID;
            }
            this.$store.dispatch('detailedProblemsByCityOrRegion', paramObj).then((response) => {
                this.problemStatisticDetailedSecondaryInfo = response.data;
                
            });
        },
        cityAndRegionByProblemType(problem_typeID){
            this.$store.dispatch("cityAndRegionByProblemType", {problem_typeID}).then((response) => {
                this.problemStatisticDetailedSecondaryInfo = response.data.cities;
            });
        },
    }
}
</script>
<style scoped>
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, min-content);
  row-gap: 1.5em;
}
/* .main-info-section{
  overflow: hidden;
} */
.problems-cards-map-wrapper{
    display: grid;
    grid-template-columns: 45% auto;
    gap: 15px;
}

textarea.blue-part-input{
    resize: none;
    height: 100px;
    padding: 8px;
}
.problem-images-wrapper img{
    max-height: 92px;
    object-fit: contain;
}
.problems-map-wrapper{
    background-color: var(--secondary-background-color);
}
.modal-photo-wrapper, .modal-photo-wrapper video{
    height: 500px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    row-gap: 1em;
}
.additional-comment .blue-part-input{
    padding: 8px 16px;
    border-radius: 1em;
    max-width: max-content
}
.common-table-container{
    height: 550px;
    padding: 0;
    border-radius: 0;
}
.common-table-container :is(td, th){
    padding: 5px 5px;
}
.common-table-container th{
    white-space: wrap;
    text-overflow: ellipsis;
}
.modal-reports-wrapper #modal-left-report-body tr{
    cursor: pointer;
}
.modal-reports-wrapper #modal-left-report-body tr:hover{
    background-color: rgba(113, 142, 191, 0.705);
}
.modal-reports-wrapper #modal-left-report-body tr.active{
    background-color: rgba(113, 142, 191, 0.705);
}
.delete-button{
    padding: 5px;
    background-color: #ffffffd1;
    border-radius: 7px;
    display: flex;
    align-items: center;
    gap: 0.5em;
    cursor: pointer;
}
.problems-comments-wrapper{
  padding-inline: 1em;
  height: 380px;
}

@media screen and (max-width: 1720px) {
    .common-table-container{
        height: 490px;
    }
    .problems-comments-wrapper{
        height: 350px;
    }
}


@media screen and (max-width: 1560px) {
    .problems-cards-map-wrapper{
        grid-template-columns: 45% auto;
    }
    .modal-photo-wrapper, .modal-photo-wrapper video{
        height: 400px;
    }
    .common-table-container{
        height: 420px;
    }
    .problems-comments-wrapper{
        padding-inline: 1em;
        height: 280px;
    }
}
/* @media screen and (max-width: 992px) {
    .problems-comments-wrapper{
        padding-inline: 1em;
        height: 260px;
    }
} */
</style>
